import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "goal-update"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("目标管理");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("目标基础信息设置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择考核团队");

const _hoisted_5 = {
  class: "tips"
};
const _hoisted_6 = {
  class: "radio-group"
};
const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("全部商品");

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("指定商品");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("选择商品");

const _hoisted_12 = {
  key: 0
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_14 = {
  key: 0,
  class: "tip",
  style: {
    "color": "#999",
    "margin-left": "10px"
  }
};
const _hoisted_15 = {
  key: 0
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("订单金额(不含运费)");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("商品底价(未设置商品底价即计算为0)");

const _hoisted_18 = {
  class: "radio-group"
};
const _hoisted_19 = {
  class: "wrapper"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("年度目标");

const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#666",
    "margin-left": "10px"
  }
}, "选择年度目标需分解目标至每月", -1);

const _hoisted_22 = {
  class: "wrapper",
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode("自定义时间");

const _hoisted_24 = {
  class: "radio-group"
};
const _hoisted_25 = {
  class: "wrapper"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode("无");

const _hoisted_27 = {
  class: "wrapper"
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode("自定义奖励");

const _hoisted_29 = {
  class: "search"
};

const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "成员姓名", -1);

const _hoisted_31 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_32 = {
  class: "toolbox"
};

const _hoisted_33 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_34 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_35 = /*#__PURE__*/_createTextVNode("模板导入");

const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "tips"
}, "默认不包含团队负责人，若需添加请新增", -1);

const _hoisted_37 = {
  class: "total"
};
const _hoisted_38 = {
  class: "table-summary"
};

const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "合计", -1);

const _hoisted_40 = {
  key: 1
};

const _hoisted_41 = /*#__PURE__*/_createTextVNode("发布");

import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import SuplierModal from './supplier-modal.vue';
import ProdModal from './prod-modal.vue';
import MemberModal from './member-modal.vue';
import ExcelModal from './excel-modal.vue';
import { targetPublish, targetNoJoinUser, targetDetail, validTargetImport } from '@/request';
export default {
  name: 'update',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      let {
        targetId
      } = route.query;
      if (targetId) getDetail();
    });
    const form = ref();
    const formData = reactive({
      targetType: 1,
      targetName: '',
      targetProd: 1,
      storeProds: [],
      targetSales: null,
      assessKpiAmount: 1,
      assessPeriod: 1,
      year: '2024',
      dateRange: [],
      rewardType: 0,
      rewardDesc: '',
      teamList: [],
      userList: []
    });
    const formRules = {
      teamList: {
        required: true,
        message: '请选择团队'
      },
      targetName: {
        required: true,
        message: '请填写目标'
      },
      targetProd: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.targetProd == 2 && !formData.storeProds.length) {
            callback(new Error('请选择商品'));
            return;
          }

          callback();
        }
      },
      targetSales: {
        required: true,
        message: '请填写目标销量'
      },
      assessPeriod: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.assessPeriod == 1 && !formData.year) {
            callback(new Error('请选择年份'));
            return;
          }

          if (formData.assessPeriod == 2 && !formData.dateRange.length) {
            callback(new Error('请选择时间'));
            return;
          }

          callback();
        }
      },
      rewardType: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.rewardType == 1 && !formData.rewardDesc) {
            callback(new Error('请填写奖励'));
            return;
          }

          callback();
        }
      }
    };
    const editDisabled = computed(() => route.query.targetId);
    const detail = ref({});
    const loading = ref(false);

    function getDetail() {
      loading.value = true;
      targetDetail({
        targetId: route.query.targetId
      }).then(res => {
        let {
          success,
          data
        } = res;
        if (!success) return;
        detail.value = data;
        formData.targetType = data.targetType;
        formData.targetName = data.targetName;
        formData.targetProd = data.targetProd;
        formData.targetSales = data.targetSales;
        formData.assessPeriod = data.assessPeriod;
        formData.rewardType = data.rewardType;
        formData.rewardDesc = data.rewardDesc;
        formData.year = data.year;

        if (data.targetProd == 2) {
          formData.storeProds = data.targetProds;
        }

        if (data.assessPeriod == 1) {// formData.year = data.year
        } else {
          formData.dateRange = [data.startTime, data.endTime];
        }

        if (data.targetType == 2) {
          formData.assessKpiAmount = data.assessKpiAmount;
        }

        formData.teamList = JSON.parse(data.teamJson);
        formData.userList = data.targetUsers.map(item => {
          if (data.assessPeriod == 1) {
            for (let i = 1; i < 13; i++) {
              let value = item.data[i - 1] ? parseFloat(item.data[i - 1]) : 0;
              item[`value_${i}`] = value == 0 ? null : value;
            }
          } else {
            let value = parseFloat(item.data[0]);
            item['value_0'] = value == 0 ? null : value;
          }

          return item;
        });
        renderMemberList();
      }).finally(() => loading.value = false);
    } // 成员分解


    const memberModal = reactive({
      show: false,
      params: {},
      selectedIds: []
    });
    const userSearchKey = ref('');
    const memberUserList = ref([]);
    const selectedMemberList = ref([]);

    function addMemberModal() {
      memberModal.show = true;
      memberModal.params = {
        taskId: formData.taskId,
        teamJson: JSON.stringify(formData.teamList),
        containOwner: 1
      };
      memberModal.selectedIds = formData.userList.map(v => v.supUserId);
    }

    function addMemberConfirm(memberList) {
      let list = memberList.map(item => {
        for (let i = 0; i < 13; i++) {
          item[`value_${i}`] = null;
        }

        return item;
      });
      formData.userList = [...list, ...formData.userList];
      renderMemberList();
    }

    function renderMemberList() {
      memberUserList.value = formData.userList.filter(item => {
        return item.linkMan.includes(userSearchKey.value);
      });
    }

    function memberTableDeleteHandle() {
      let currentMemberList = [...formData.userList];
      formData.userList = currentMemberList.filter(item => {
        return Boolean(selectedMemberList.value.find(v => v.supUserId == item.supUserId)) === false;
      });
      userSearchKey.value = '';
      renderMemberList();
      ElMessage.success('删除成功');
    }

    function getSummaryRow(index) {
      let dataList = formData.userList.map(item => item[`value_${index}`]);
      let value = dataList.reduce((pre, cur) => pre + cur, 0);

      if (String(value).includes('.')) {
        value = value.toFixed(2);
      }

      return parseFloat(value);
    }

    const tableSummary = computed(() => {
      let sum = 0;

      if (formData.assessPeriod == 1) {
        for (let i = 1; i < 13; i++) {
          sum += getSummaryRow(i);
        }
      } else {
        sum = getSummaryRow(0);
      }

      if (String(sum).includes('.')) {
        sum = sum.toFixed(2);
      }

      return parseFloat(sum);
    });

    function validSummary(item, key, value) {
      if (value == null) return;

      if (!formData.targetSales) {
        ElMessage.error('未设置团队目标总值');
        item[key] = null;
        return;
      }

      if (tableSummary.value > formData.targetSales) {
        ElMessage.error('成员目标总值大于团队目标总值，无法设置');
        item[key] = null;
        return;
      }
    } // 团队选择


    const supplierModalShow = ref(false);
    const suppliersName = computed(() => {
      let teamList = formData.teamList;
      if (teamList.length == 0) return;
      let str = '';
      let levelTypeList = ['0', '1', '2'];
      levelTypeList.forEach(levelType => {
        str += teamList.filter(v => v.levelType == levelType).map(v => v.text).join();

        if (levelType != '2') {
          str += '__';
        }
      });
      return str;
    });
    const defauleCheckedSupplierId = computed(() => {
      return formData.teamList.map(v => v.id);
    });

    function getSelectedSupplier(e) {
      if (e.length == 0) return;
      formData.teamList = e.map(item => {
        let obj = {};
        let idList = item.id.split('-');

        if (idList.length > 1) {
          obj.teamId = idList[0];
          obj.structureId = idList[1];
        } else {
          obj.teamId = idList[0];
        }

        obj.text = item.text;
        obj.levelType = item.levelType;
        obj.id = item.id;
        return obj;
      });
      formData.storeProds = []; // console.log(formData.teamList)
      // return

      let teamList = formData.teamList.map(item => ({
        teamId: item.teamId,
        structureId: item.structureId
      }));
      let params = {
        teamJson: JSON.stringify(teamList),
        page: 1,
        pageSize: 3000,
        containOwner: 0
      };
      targetNoJoinUser(params).then(res => {
        if (!res.success) return;
        let data = res.data.slice(0, 500);
        let list = data.map(item => {
          for (let i = 0; i < 13; i++) {
            item[`value_${i}`] = null;
          }

          return item;
        });
        formData.userList = list;
        renderMemberList();

        if (list.length == 500) {
          ElMessage.warning('团队人数过多，已限制加载为500人');
        }
      });
    } // 选择商品


    const prodModal = ref({
      show: false,
      params: {}
    });

    function selectProdHandle() {
      let selectTeamList = formData.teamList;

      if (selectTeamList.length === 0) {
        ElMessage.warning('请先选择团队');
        return;
      }

      prodModal.value = {
        show: true,
        params: {
          supplierId: selectTeamList[0].teamId,
          structureId: selectTeamList[0].structureId
        }
      };
    }

    function selectProdConfirm(prods) {
      formData.storeProds = [...prods, ...formData.storeProds];
    }

    function deleteProdHandle(prodNo) {
      let prodList = [...formData.storeProds];
      let deleteIndex = prodList.findIndex(item => item.prodNo == prodNo);
      prodList.splice(deleteIndex, 1);
      formData.storeProds = prodList;
    } // 发布


    function submit() {
      form.value.validate(e => {
        if (!e) return; // 成分分解校验， 年度区间成员必须填写1个月，自定义区间必须填写

        if (formData.assessPeriod == 1) {
          // 年度
          let yearValueKey = ['value_1', 'value_2', 'value_3', 'value_4', 'value_5', 'value_6', 'value_7', 'value_8', 'value_9', 'value_10', 'value_11', 'value_12'];
          let everyUserValid = formData.userList.every(item => {
            return yearValueKey.some(key => item[key]);
          });

          if (everyUserValid == false) {
            ElMessage.error('团队成员需至少填写一个月目标值');
            return;
          }
        } else {
          let everyUserValid = formData.userList.every(item => item.value_0);

          if (everyUserValid == false) {
            ElMessage.error('团队成员目标值填写不完整');
            return;
          }
        }

        let body = {
          targetType: formData.targetType,
          targetName: formData.targetName,
          targetSales: formData.targetSales,
          targetProd: formData.targetProd,
          assessPeriod: formData.assessPeriod,
          rewardType: formData.rewardType,
          targetTeams: formData.teamList
        };

        if (formData.targetProd == 2) {
          // 指定商品
          body.storeProdNos = formData.storeProds.map(v => v.prodNo).join();
        }

        if (formData.targetType == 1) {
          // 考核指标
          body.assessKpiQuantity = '出库订单中的商品数量（不含赠品）';
        } else {
          body.assessKpiAmount = formData.assessKpiAmount;
        }

        if (formData.assessPeriod == 1) {
          // 考核周期
          body.year = formData.year;
        } else {
          if (!editDisabled.value) {
            body.startTime = formData.dateRange[0] + ' 00:00:00';
            body.endTime = formData.dateRange[1] + ' 23:59:59';
          } else {
            body.startTime = formData.dateRange[0];
            body.endTime = formData.dateRange[1];
          }
        }

        if (formData.rewardType == 1) {
          // 自定义奖励
          body.rewardDesc = formData.rewardDesc;
        }

        body.targetUsers = formData.userList.map(item => {
          return {
            supUserId: item.supUserId,
            data: formData.assessPeriod == 1 ? [item.value_1, item.value_2, item.value_3, item.value_4, item.value_5, item.value_6, item.value_7, item.value_8, item.value_9, item.value_10, item.value_11, item.value_12] : [item.value_0]
          };
        });
        let targetId = route.query.targetId;
        targetId && (body.targetId = targetId);
        targetPublish(body).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success('操作成功');
            router.go(-1);
          } else {
            ElMessage.error(msg);
          }
        });
      });
    } // 导入导出模板


    const excelModalShow = ref(false);

    function getExcelTable(data) {
      console.log(data); // 校验成员是否存在以及目标值均填写

      let userFillValid = data.every(item => item.supUserId && item.linkMan);

      if (!userFillValid) {
        ElMessage.error('导入失败，请确认团队成员存在');
        return;
      }

      let validbody = {
        userList: data.map(v => ({
          supUserId: v.supUserId,
          linkMan: v.linkMan
        })),
        teamList: formData.teamList
      };
      validTargetImport(validbody).then(res => {
        if (!res.success) {
          ElMessage.error(res.msg);
          return;
        }

        if (res.data.length > 0) {
          ElMessage.error('导入失败，请确认团队成员存在');
          return;
        }

        formData.userList = data;
        renderMemberList();
      });
    }

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'goal'
            }
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.targetName || '新建目标'), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formData,
        rules: formRules,
        "label-position": "right",
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_card, null, {
          header: _withCtx(() => [_hoisted_3]),
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "目标类型",
            prop: "targetType",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.targetType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.targetType = $event),
              style: {
                "width": "200px"
              },
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "销量",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "销售额",
                value: 2
              })]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "考核团队",
            prop: "teamList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              disabled: _unref(editDisabled),
              onClick: _cache[1] || (_cache[1] = $event => supplierModalShow.value = true)
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }, 8, ["disabled"]), _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(suppliersName)), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "目标名称",
            prop: "targetName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.targetName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.targetName = $event),
              placeholder: "请输入目标名称",
              style: {
                "width": "400px"
              },
              disabled: _unref(editDisabled),
              maxLength: "30"
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "目标产品",
            class: "block",
            prop: "targetProd"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_radio, {
              modelValue: formData.targetProd,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.targetProd = $event),
              label: 1,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_radio, {
              modelValue: formData.targetProd,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.targetProd = $event),
              label: 2,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }, 8, ["modelValue", "disabled"]), formData.targetProd == 2 && !_unref(editDisabled) ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: selectProdHandle
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            })) : _createCommentVNode("", true)])]), formData.targetProd == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_table, {
              data: formData.storeProds,
              class: "prod-list",
              size: "small",
              style: {
                "width": "400px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "商品名称",
                prop: "prodName"
              }), !_unref(editDisabled) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                prop: "prodNo",
                width: "80"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  size: "small",
                  onClick: $event => deleteProdHandle(scope.row.prodNo)
                }, {
                  default: _withCtx(() => [_hoisted_13]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["data"])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: formData.targetType == 1 ? '目标销量' : '目标销售额',
            prop: "targetSales"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.targetSales,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.targetSales = $event),
              "controls-position": "right",
              min: 1,
              max: 9999999999999,
              disabled: _unref(editDisabled),
              precision: formData.targetType == 1 ? 0 : 2
            }, null, 8, ["modelValue", "disabled", "precision"]), formData.targetType == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "仅计算出库订单金额")) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: "考核指标",
            required: "",
            prop: "targetType"
          }, {
            default: _withCtx(() => [formData.targetType == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "出库订单中的商品数量（不含赠品）")) : (_openBlock(), _createBlock(_component_el_radio_group, {
              key: 1,
              modelValue: formData.assessKpiAmount,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.assessKpiAmount = $event),
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_16]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_17]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue", "disabled"]))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "考核周期",
            class: "block no-input-red",
            prop: "assessPeriod"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_radio, {
              modelValue: formData.assessPeriod,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.assessPeriod = $event),
              label: 1,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_20]),
              _: 1
            }, 8, ["modelValue", "disabled"]), _createVNode(_component_el_date_picker, {
              modelValue: formData.year,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.year = $event),
              type: "year",
              style: {
                "width": "160px"
              },
              placeholder: "年份",
              "value-format": "YYYY",
              disabled: _unref(editDisabled)
            }, null, 8, ["modelValue", "disabled"]), _hoisted_21]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_radio, {
              modelValue: formData.assessPeriod,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.assessPeriod = $event),
              label: 2,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_23]),
              _: 1
            }, 8, ["modelValue", "disabled"]), _createVNode(_component_el_date_picker, {
              modelValue: formData.dateRange,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.dateRange = $event),
              type: "daterange",
              "value-format": "YYYY-MM-DD",
              style: {
                "flex": "0 0 300px"
              },
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "unlink-panels": "",
              disabled: _unref(editDisabled),
              disabledDate: date => Date.now() > date.getTime() + 24 * 60 * 60 * 1000
            }, null, 8, ["modelValue", "disabled", "disabledDate"])])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "达成奖励"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_radio, {
              modelValue: formData.rewardType,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.rewardType = $event),
              label: 0,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_26]),
              _: 1
            }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_radio, {
              modelValue: formData.rewardType,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.rewardType = $event),
              label: 1,
              disabled: _unref(editDisabled)
            }, {
              default: _withCtx(() => [_hoisted_28]),
              _: 1
            }, 8, ["modelValue", "disabled"])]), _createVNode(_component_el_input, {
              modelValue: formData.rewardDesc,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.rewardDesc = $event),
              type: "textarea",
              placeholder: "请输入自定义奖励，可描述奖励内容、奖励方式、奖励时间等",
              style: {
                "width": "500px"
              },
              maxLength: "100",
              disabled: _unref(editDisabled)
            }, null, 8, ["modelValue", "disabled"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_card, {
          class: "membership"
        }, {
          header: _withCtx(() => [_createTextVNode("目标分解（" + _toDisplayString(formData.userList.length) + "人）", 1)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_input, {
            modelValue: userSearchKey.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => userSearchKey.value = $event),
            placeholder: "请输入成员姓名",
            style: {
              "width": "200px",
              "margin-right": "10px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: renderMemberList
          }, {
            default: _withCtx(() => [_hoisted_31]),
            _: 1
          })]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_button, {
            type: "danger",
            disabled: !selectedMemberList.value.length,
            onClick: memberTableDeleteHandle
          }, {
            default: _withCtx(() => [_hoisted_33]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_button, {
            type: "primary",
            disabled: !formData.teamList.length,
            onClick: addMemberModal
          }, {
            default: _withCtx(() => [_hoisted_34]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = $event => excelModalShow.value = true)
          }, {
            default: _withCtx(() => [_hoisted_35]),
            _: 1
          }), _hoisted_36]), _createElementVNode("div", _hoisted_37, "成员目标值合计：" + _toDisplayString(_unref(tableSummary)), 1), _createVNode(_component_el_table, {
            data: memberUserList.value,
            maxHeight: "600px",
            onSelectionChange: _cache[18] || (_cache[18] = list => selectedMemberList.value = list)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "操作",
              type: "selection",
              width: "55"
            }), _createVNode(_component_el_table_column, {
              label: "团队成员",
              prop: "linkMan",
              width: "100"
            }), formData.assessPeriod == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(12, i => {
              return _createVNode(_component_el_table_column, {
                label: i + '月'
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                  modelValue: scope.row[`value_${i}`],
                  "onUpdate:modelValue": $event => scope.row[`value_${i}`] = $event,
                  "controls-position": "right",
                  min: 1,
                  max: 999999999,
                  style: {
                    "width": "80px"
                  },
                  onBlur: $event => validSummary(scope.row, `value_${i}`, scope.row[`value_${i}`]),
                  controls: false,
                  onWheel: _cache[16] || (_cache[16] = _withModifiers(() => false, ["prevent"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
                _: 2
              }, 1032, ["label"]);
            }), 64)) : (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "分解任务量"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row['value_0'],
                "onUpdate:modelValue": $event => scope.row['value_0'] = $event,
                "controls-position": "right",
                min: 1,
                max: 999999999,
                style: {
                  "width": "160px"
                },
                onBlur: $event => validSummary(scope.row, 'value_0', scope.row['value_0']),
                controls: false,
                onWheel: _cache[17] || (_cache[17] = _withModifiers(() => false, ["prevent"]))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
              _: 1
            }))]),
            _: 1
          }, 8, ["data"]), _createElementVNode("div", _hoisted_38, [_hoisted_39, formData.assessPeriod == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(12, i => {
            return _createElementVNode("span", null, _toDisplayString(getSummaryRow(i)), 1);
          }), 64)) : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(getSummaryRow(0)), 1))])]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          style: {
            "width": "200px",
            "margin-top": "20px"
          },
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_41]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(SuplierModal, {
        modelValue: supplierModalShow.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => supplierModalShow.value = $event),
        defaultChecked: _unref(defauleCheckedSupplierId),
        onSuccess: getSelectedSupplier
      }, null, 8, ["modelValue", "defaultChecked"]), _createVNode(ProdModal, {
        modelValue: prodModal.value.show,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => prodModal.value.show = $event),
        params: prodModal.value.params,
        selectedProd: [],
        onSuccess: selectProdConfirm
      }, null, 8, ["modelValue", "params"]), _createVNode(MemberModal, {
        params: memberModal.params,
        selectedIds: memberModal.selectedIds,
        modelValue: memberModal.show,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => memberModal.show = $event),
        onSuccess: addMemberConfirm
      }, null, 8, ["params", "selectedIds", "modelValue"]), _createVNode(ExcelModal, {
        modelValue: excelModalShow.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => excelModalShow.value = $event),
        data: formData.userList,
        timeType: formData.assessPeriod,
        onSuccess: getExcelTable
      }, null, 8, ["modelValue", "data", "timeType"])])), [[_directive_loading, loading.value]]);
    };
  }

};